import { message, Modal, notification } from 'antd'
import {
  AppConfig,
  AppStore,
  GameLibraryStore,
  HaiShaJsqStore,
  WallpaperStore,
  ApplyModStore,
} from 'src/pc/store/AppStore'
import {
  ClosePluginTipContent,
  CloseSDTipContent,
  GameAccountExtracted,
  HasGameRunningModalContent,
  JsErrorTip,
  OutOfMemoryTips,
  platformNotInstallTips,
  WifiNetworkTips,
} from 'src/commons/utils/DOMUtils'
import {
  ChannelConfigHS,
  DWGetMultipleModDataByModIdHttp,
  DWSaveUrlHttp,
  GetPreProcessHS,
  statisticsApiHS,
  WallpaperListHS,
} from 'src/commons/store/BasisStore'
import {
  checkModal,
  checkPageJump,
  DoStartGame,
  gameStartingSuccess,
  getClientName,
  getCMSVersion,
  HideCheckModal,
  HideGameArchives,
  loadLinkGame,
  OpenCustomerService,
  openNotification,
  ReStartGame,
  toStoreGameDetail,
  UninstallMkf,
} from 'src/pc/store/UIController'
import { useWaitModData } from '@hhpack/use-cms'
import { loginSuccess } from 'src/pc/store/UserStore'
import { GetChannel, getInstalledGameList, reportLogin } from 'src/commons/utils/index'
import { DWGetGameLibraryInfoByGoodsId, MyGameListHS } from 'src/commons/store/GameStore'
import { history, loadChannelConfigPhp } from 'src/commons/utils/WebCommons'
import { getPhpToken } from 'src/pc/utils/auth'
import DDModal from 'src/pc/components/DDModal'
import SpeedBallStore from 'src/pc/store/SpeedBallStore'
import { gameStartStep } from 'src/pc/components/GameStartStep'

/**杀软配置*/
const SDConfig: { [key: string]: string } = {}
/**反外挂消息配置*/
const FWGConfig: { [key: string]: { status: '0' | '1'; content: string } } = {}
let DoNetTips: string | null = null
const GetSDSoftName = (msg: string): string => {
  if (Number.isNaN(Number(msg))) {
    const type = msg.replace('please close ', '') as SafeType
    return SDConfig[type] || '未知'
  }
  const nameType = {
    20: '360安全卫士',
    21: '360杀毒',
    23: '百度卫士',
    24: '百度杀毒',
    25: '卡巴斯基',
    26: '火绒',
    27: '电脑管家',
    28: '金山卫士',
  }
  return nameType[msg as '20' | '21' | '23' | '24' | '25' | '26' | '27' | '28'] || '未知'
}

const GetPlatformName = (originMsg: string): string => {
  let Name = ''
  if (originMsg === 'failed to find steam path') {
    Name = 'Steam'
  } else if (originMsg === 'failed to find origin path') {
    Name = 'EA'
  } else if (originMsg === 'failed to find uplay path') {
    Name = 'Uplay'
  } else if (originMsg === 'failed to find epic path') {
    Name = 'Epic'
  } else if (originMsg === 'failed to find battlenet path') {
    Name = 'BattleNet'
  } else if (originMsg === 'failed to find riot path') {
    Name = 'Riot'
  }
  return Name
}

/**加载客户端所需的 CMS 配置*/
const LoadCMSConfigForClient = () => {
  const modIds = ['simpleshq_message_toast', 'simpleshq_mygame', 'simpleshq_tools_install'].join(',')
  getCMSVersion().then(version => {
    DWGetMultipleModDataByModIdHttp.Execute({ modIds, version }).then((data: Array<ModData<any>>) => {
      data.forEach(d => {
        switch (d.modId) {
          case 'simpleshq_message_toast':
            return LoadFWGConfig(d)
          case 'simpleshq_mygame':
            return LoadSDConfig(d)
          case 'simpleshq_tools_install':
            return LoadDoNetTips(d)
          default:
            return null
        }
      })
    })
  })
}

/**加载杀毒软件配置*/
const LoadSDConfig = (data: ModData<{ value: string; cnvalue: string }>) => {
  const SDData = data.datas[0]
  if (SDData) {
    //const SDConfig: { [key: string]: string } = {}
    const SDType = SDData.properties.value.split(',')
    const SDName = SDData.properties.cnvalue.split(',')
    SDType.forEach((d, i) => {
      SDConfig[d] = SDName[i]
    })
    //SDConfig = SDConfig
  }
}

/**加载反外挂消息配置*/
const LoadFWGConfig = (data: ModData<{ string: string; status: '0' | '1'; content: string }>) => {
  data.datas.forEach(d => {
    FWGConfig[d.properties.string] = { content: d.properties.content, status: d.properties.status }
  })
}
/**加载.Net 重启提示*/
const LoadDoNetTips = (data: ModData<{ content: string }>) => {
  const res = data.datas[0]
  if (res) {
    DoNetTips = res.properties.content
  }
}

const LoadChannelConfig = async (ToGame: boolean, ver?: string, notInClient?: boolean) => {
  const channelConfigRes = await loadChannelConfigPhp(ver)
  localStorage.setItem('notFirstInLoadChannelConfig', '1')
  ToGame && checkPageJump(channelConfigRes)
}

export default () => {
  const Methods = {
    cpp2js_game_login_failed: (code: string, msg: string) => {
      const MAP: Record<string, string> = {
        '401': `游戏启动失败，失败原因：CPU负载过高，建议您退出部分软件后，再进行游戏启动`,
        '402': `游戏启动失败，失败原因：运行内存不足，建议您退出部分软件后，再进行游戏启动`,
      }
      AppStore.CheckModalVisible = false
      DDModal.confirm({
        title: '提示',
        content: MAP[code] || msg || '',
        cancelText: '联系客服',
        onCancel: () => {
          OpenCustomerService()
        },
        okText: '知道了',
      })
      HideCheckModal()
    },
    cpp2js_anticheat_start_failed: (code: string, msg: string) => {
      const MAP: Record<string, string> = {
        '101': `磁盘空间不足，游戏启动失败；请清理${msg}盘留出至少100M空间后重试启动游戏`,
        '102': `系统检测到您当前设置网络连接受限，受限原因：DNS地址被修改，请重置后再进行游戏启动重试`,
        '104': `系统检测到您当前设置网络连接受限，启动游戏失败，请更换网络后再进行游戏启动重试`,
        '105': `请保证当前客户端系统盘至少空余100MB空间后再进行游戏启动重试！`,
      }
      AppStore.CheckModalVisible = false
      if (code === '102') {
        DDModal.confirm({
          title: '提示',
          content: MAP[code] || msg || '',
          okText: '重置DNS',
          cancelText: '我知道了',
          onOk: () => {
            window.FuluApp?.JSNotifyCppFunc('reset_dns')
            message.success('DNS重置成功')
          },
        })
      } else {
        DDModal.confirm({
          title: '提示',
          content: MAP[code] || msg || '',
          cancelText: '联系客服',
          onCancel: () => {
            OpenCustomerService()
          },
          okText: '知道了',
        })
      }
      HideCheckModal()
    },
    cpp2js_game_status: (originMsg: GameStatus) => {
      console.log('cpp2js_game_status', originMsg)
      GameLibraryStore.refreshGameStartInfo = GameLibraryStore.refreshGameStartInfo + 1
      AppStore.LoginGaming = false
      const FWGMsgInfo = FWGConfig[originMsg]
      if (FWGMsgInfo) {
        if (FWGMsgInfo.status === '0') {
          /*失败消息*/
          HideCheckModal()
          window.FuluApp?.JSNotifyCppFunc('set_window_foreground')
          DDModal.confirm({
            title: '提示',
            content: FWGMsgInfo.content,
            cancelText: '联系客服',
            onCancel: () => {
              OpenCustomerService()
            },
            okText: '知道了',
          })
        }
      } else {
        HideCheckModal()
        window.FuluApp?.JSNotifyCppFunc('set_window_foreground')
        if (originMsg === 'password wrong') {
          //账号密码错误
          DDModal.confirm({
            title: '提示',
            content: 'Steam账号密码错误!',
            cancelText: '联系客服',
            onCancel: () => {
              OpenCustomerService()
            },
            okText: '知道了',
          })
          return false
        }
        if (
          [
            'failed to find steam path',
            'failed to find origin path',
            'failed to find uplay path',
            'failed to find epic path',
            'failed to find riot path',
          ].includes(originMsg)
        ) {
          AppStore.GameCheckErrorStepMessage = `您的电脑未安装${GetPlatformName(originMsg)}软件!`
          AppStore.GameCheckErrorStep = 1
          AppStore.GameCheckStep = 1
          return false
        }
        if (
          [
            '360tray',
            '360sd',
            'BaiduAn',
            'BaiduSd',
            'HipsTray',
            'avp',
            'ksafe',
            'QQPCTray',
            '20',
            '21',
            '23',
            '24',
            '25',
            '26',
            '27',
            '28',
          ].includes(originMsg)
        ) {
          //安装了安全软件
          //过白中不提示关闭杀软
          if (!(ChannelConfigHS.SuccessResult && ChannelConfigHS.SuccessResult.is_checking)) {
            DDModal.confirm({
              title: '提示',
              content: CloseSDTipContent(GetSDSoftName(originMsg)),
              cancelText: '联系客服',
              onCancel: () => {
                OpenCustomerService()
              },
              okText: '知道了',
            })
          }
          return false
        }
        if (originMsg.includes('外挂')) {
          if (AppStore.RunningGameName) {
            Modal.confirm({
              ...ClosePluginTipContent(AppStore.RunningGameName),
              className: 'custom PluginWarning',
              width: 600,
              onCancel: () => {
                OpenCustomerService()
              },
              centered: true,
              okText: '文明玩游戏',
              cancelText: '误判，联系客服',
            })
          }
          return false
        }
        if (originMsg.includes('账号已提取')) {
          GameAccountExtracted(originMsg)
          return false
        }
        /** 50100 是客户端定义的异常错误, 暂时屏蔽弹窗, 后续客户端优化处理 */
        if (originMsg.indexOf('[50100]') < 0) {
          DDModal.confirm({
            title: '提示',
            content: originMsg,
            cancelText: '联系客服',
            onCancel: () => {
              OpenCustomerService()
            },
            okText: '知道了',
          })
        }
      }
      return null
    },
    /** 广告弹框 透传过来的消息 */
    cpp2js_popup_window_msg: (params: string) => {
      const finalParams: { target: 'in' | 'out'; url: string } = JSON.parse(params)
      localStorage.setItem('notificationClick', 'true')
      if (finalParams.target === 'in') {
        history.push(finalParams.url)
      } else {
        window.FuluApp?.JSNotifyCppFunc('open_url', finalParams.url)
      }
    },
    cpp2js_need_close_antivirus: (antivirusName: string, canMakesureClose: 0 | 1) => {
      AppStore.LoginGaming = false
      DDModal.confirm({
        title: '提示',
        content: CloseSDTipContent(antivirusName),
        cancelText: '联系客服',
        onCancel: () => {
          OpenCustomerService()
        },
        okText: '知道了',
      })
    },
    cpp2js_redirect_frame_url: (url: string) => {
      const event = new CustomEvent('cpp2js_redirect_frame_url', { detail: url })
      window.dispatchEvent(event)
    },
    cpp2js_load_antiplugin_failed: (reason: number) => {
      AppStore.LoginGaming = false
      if (reason === 2 || reason === 3) {
        DDModal.confirm({
          title: '提示',
          content: '启动反外挂失败！请您确保您已经关闭了杀毒软件。',
          cancelText: '联系客服',
          onCancel: () => {
            OpenCustomerService()
          },
          okText: '知道了',
        })
      } else {
        DDModal.confirm({
          title: '提示',
          content: '下载反外挂失败！',
          cancelText: '联系客服',
          onCancel: () => {
            OpenCustomerService()
          },
          okText: '知道了',
        })
      }
    },
    cpp2js_version_notify: (ver: string) => {
      LoadChannelConfig(true, ver)
    },
    cpp2js_steam_updating: () => {
      message.warn('正在安装或更新Steam客户端,请稍后....')
      AppStore.LoginGaming = false
    },
    cpp2js_notify_game_run_steps: (Step: number, IsSuccess: 0 | 1, Message: string) => {
      if (AppStore.GameCheckStep >= Step && Step !== 0) {
        return
      }
      AppStore.GameCheckStep = Step
      gameStartStep.setStep(Step + 1)
      if (IsSuccess === 0) {
        //检测失败
        if (Step === 0) {
          const SDSoftName = GetSDSoftName(Message)
          const modal = Modal[SDSoftName?.includes('迈克菲') ? 'confirm' : 'warn']({
            title: '反外挂系统提示',
            content: `为了启动反外挂服务，保护您的账号安全您需要手动退出"${SDSoftName}"`,
            okText: '已关闭杀软',
            className: 'custom AllowClose',
            zIndex: 1006,
            style: { top: 250 },
            cancelText: '立即卸载',
            onOk: () => {
              ReStartGame()
            },
            cancelButtonProps: {
              onClick: () => {
                UninstallMkf()
                HideCheckModal()
                modal.destroy()
              },
            },
            onCancel: () => {
              HideCheckModal()
            },
          })
          AppStore.GameCheckErrorStepMessage = `请手动退出"${SDSoftName}"!`
        } else if (Step === 1) {
          console.log(GameLibraryStore.currentTheRunningGameInfo, 'GameLibraryStore.currentTheRunningGameInfo')
          const PlatformName = GetPlatformName(Message)
          platformNotInstallTips(PlatformName)
          AppStore.GameCheckErrorStepMessage = `您的电脑未安装${PlatformName}软件!`
        } else {
          AppStore.GameCheckErrorStepMessage = Message
        }
        AppStore.GameCheckErrorStep = Step
      } else if (Step === 2) {
        /*成功到第二步 清除临时选择配置*/
        sessionStorage.removeItem('WIFINotShow')
        sessionStorage.removeItem('MemoryNotShow')
        sessionStorage.removeItem('UseCurrentNetwork')
      }
      if (Step === 4) {
        GameLibraryStore.gameRunStatus = 'running'
        if (GameLibraryStore.currentTheRunningGameInfo) {
          /** 记录启动游戏时间 */
          GameLibraryStore.currentTheRunningGameInfo!.gameStartTime = Date.now()
        }
        /*检测成功*/
        gameStartingSuccess()
        HideGameArchives()
      }
    },
    /**
     * 平台是否安装检测
     * @param Step
     * @param IsSuccess
     * @param Message
     */
    cpp2js_notify_check_gameplatform_install_status: (platform: string, status: number) => {
      AppStore.platformInstallStatus[platform] = status
      if (status !== 1) {
        const map = {
          '1': 'Steam',
          '2': 'EA',
          '4': 'Uplay',
          '5': 'Epic',
          '6': 'BattleNet',
          '9': 'Riot',
          '20': 'BlackSmith',
        }
        const platformName = map[String(platform) as keyof typeof map]
        platformNotInstallTips(platformName, platform as keyof typeof map)
      }
    },
    /**
     * 开始游戏前的环境检测：内存、cpu、wifi、操作系统
     * @param type 0--检测系统版本（版本对应数字），1--检测是否是wifi连接 （0.不是wifi  1.是wifi） 2--检测cpu占用率（返回百分比） 3--检测内存剩余空间(剩余空间 单位GB)
     * @param IsSuccess 状态，默认1
     * @param value
     */
    cpp2js_notify_game_env_check_steps: (type: number, IsSuccess: 0 | 1, value: string) => {
      if (typeof AppStore.gameEnvStatus[type] === 'undefined') {
        AppStore.gameEnvStatus[type] = value
      }
    },
    cpp2js_notify_gameplatform_start_login(platform: GamePlatform) {
      AppStore.gameUpdatedCompleted = true
    },
    /** 最大化/窗口化切换兼容旧版本客户端 */
    cpp2js_notify_window_iszoomed: (status: 0 | 1) => {
      AppStore.windowStatus = status
    },
    /** 窗口全屏切换兼容旧版本客户端 */
    cpp2js_full_screen_status: (status: 0 | 1) => {
      const currentStatus = AppStore.windowStatus
      AppStore.windowStatus = status === 1 ? 2 : currentStatus === 2 ? 0 : currentStatus
    },
    cpp2js_window_status_change: (status: 0 | 1 | 2) => {
      console.debug(`%c 客户端通知窗口状态变更为: ${status}`, 'font-size:20px;font-weight:bold;color:#7fea2d;')
      AppStore.windowStatus = status
    },
    /** 配合客户端修改快捷方式需求
     * @see https://www.tapd.cn/53495375/prong/stories/view/1153495375001005134?url_cache_key=18077c0c911761c8bb5caaa044e9ee3b&action_entry_type=stories
     */
    cpp2js_notify_link_gameid: (linkGameid: number | string) => {
      loadLinkGame(linkGameid)
    },
    /**
     * 游戏平台安装状态
     * @param platform 游戏平台
     * @param status 安装状态 0:未安装,1:已安装,2:下载中,3:正在安装
     * */
    cpp2js_notify_gameplatform_install_status: (platform: GamePlatform, status: 0 | 1 | 2 | 3) => {
      const onUserGameList = (userGameList: MyGame[]) => {
        userGameList.find(d => {
          if ([2, 9, 6].includes(Number(platform)) && d.platform === platform) {
            const onOk = () => {
              AppStore.GameToolVisible = true
              const config = AppStore.GamePlatformConfig[platform]
              config &&
                window.FuluApp?.JSNotifyCppFunc(
                  'notify_download_gameplatform',
                  platform,
                  config.md5,
                  config.url,
                  config.extend,
                )
              notification.close(platform)
            }
            // notification.open({
            //   key: platform,
            //   className: StyledNotification,
            //   duration: null,
            //   message: '提示',
            //   top: 70,
            //   description: `您购买了${PlatformText[platform]}平台游戏,但是您未安装${PlatformText[platform]}平台，是否立即下载？`,
            //   btn: DownloadPlatform(onOk),
            // })
            return true
          }
          return false
        })
      }
      if (status === 0) {
        const UserGameList = MyGameListHS.SuccessResult
        const token = getPhpToken()
        if (token) {
          if (UserGameList) {
            onUserGameList(UserGameList)
          } else {
            /**如果没有拉取了用户的游戏列表数据*/
            MyGameListHS.Execute({ token, tab: 'box' }).then(data => {
              onUserGameList(data)
            })
          }
        }
      }
      AppStore.GamePlatformInstallStatus[platform] = status
    },
    cpp2js_notify_wallpaper_status: (status: 0 | 1) => {
      AppStore.WallpaperIn = status === 1
    },
    cpp2js_notify_gameplatform_download_progress: (platform: GamePlatform, progress: number) => {
      console.log(progress, 'AppStore.GamePlatformInstallStatus')
      AppStore.GamePlatformInstallStatus[platform] = 2 + progress / 100
    },
    cpp2js_notify_update_progress: (progress: number) => {
      AppStore.GamePlatformUpdateStatus = progress
    },
    cpp2js_local_wallpaper_cfg: (data: string) => {
      WallpaperStore.LocalWallpaperListLoading = false
      const WallpaperCfg = JSON.parse(data)
      const List: Array<WallpaperList> = []
      const IdList: number[] = []
      WallpaperCfg.data?.forEach((d: { origin: string; path: string }) => {
        const Wallpaper: WallpaperList = JSON.parse(d.origin)
        Wallpaper.file = `file:///${d.path}`
        Wallpaper.InLocal = true
        IdList.push(Wallpaper.id)
        List.push(Wallpaper)
      })
      WallpaperStore.LocalWallpaperList = List
      WallpaperStore.LocalWallpaperListID = IdList
      WallpaperStore.CurrentWallpaperId = WallpaperCfg.use_id
    },
    cpp2js_download_progress: (wallpaperId: number, percent: string) => {
      const WallpaperList = WallpaperListHS.SuccessResult
      WallpaperList?.data.forEach(d => {
        if (d.id === wallpaperId) {
          const Percent = parseFloat(percent)
          Object.assign(d, { DownloadProgress: Number((Percent * 100).toFixed()) })
          // d.DownloadProgress = Number((Percent * 100).toFixed())
        }
      })
    },
    cpp2js_download_wallpaper_result: (wallpaperId: number, result: 0 | 1) => {
      const WallpaperList = WallpaperListHS.SuccessResult
      WallpaperList?.data.forEach(d => {
        if (d.id === wallpaperId) {
          if (result === 1) {
            //下载成功
            WallpaperStore.LocalWallpaperListID.push(wallpaperId)
            // d.DownloadProgress = 100
            Object.assign(d, { DownloadProgress: 100 })
            if (!d.ShowDetail) {
              window.FuluApp!.JSNotifyCppFunc('apply_wallpaper', wallpaperId) //应用当前壁纸
              WallpaperStore.CurrentWallpaperId = wallpaperId
              const Wallpaper: WallpaperList = { ...d }
              Wallpaper.InLocal = true
              delete Wallpaper.DownloadProgress
              delete Wallpaper.ShowDetail
              delete Wallpaper.IsPause
              WallpaperStore.LocalWallpaperList.push(Wallpaper)
            }
          } else {
            message.warn('壁纸下载失败!')
          }
        }
      })
    },
    cpp2js_manual_open_aero: () => {
      DDModal.warn({
        title: '提示',
        content: '设置动态壁纸失败！请手动开启Aero主题。',
        okText: '查看帮助',
        onOk: () => {
          window.FuluApp!.JSNotifyCppFunc('open_url', 'https://www.99box.com/bbs/thread-29-1-1.html')
        },
      })
    },
    cpp2js_get_platform_download_info: async (platform: GamePlatform) => {
      // console.log('cpp2js_get_platform_download_info',platform)
      const handler = () => {
        const ChannelConfig = ChannelConfigHS.SuccessResult
        if (!(ChannelConfig && ChannelConfig.is_checking === 1)) {
          const next = () => {
            /*非过白中*/
            const config = AppStore.GamePlatformConfig[platform]
            // console.log('notify_gameplatform_download_info',platform, config?.url)
            if (config) {
              window.FuluApp!.JSNotifyCppFunc(
                'notify_gameplatform_download_info',
                platform,
                config.md5,
                config.url,
                config.extend,
              )
            }
          }
          const token = getPhpToken()
          //是否uplay\epic平台
          const flag = String(platform) === '4' || String(platform) === '5'
          //未登录、uplay\epic不回复下载地址
          if (flag && !token) {
            // console.log('未登录，不回复下载地址')
            return
          }

          const UserGameList = MyGameListHS.SuccessResult
          const hasPlatform = (userGameList: MyGame[]) => {
            return userGameList.find(d => {
              return String(d.platform) === String(platform)
            })
          }
          if (flag && token) {
            // 登录情况下 ,看是否有epic\uplay的游戏
            if (UserGameList && !hasPlatform(UserGameList)) {
              // console.log('没有epic、uplay平台游戏',platform)
              return
            }
            if (!UserGameList) {
              /**如果没有拉取了用户的游戏列表数据*/
              MyGameListHS.Execute({ token, tab: 'box' }).then(data => {
                if (hasPlatform(data)) {
                  next()
                }
                // else{
                //   console.log('没有epic、uplay平台游戏===',platform)
                // }
              })
            }
          }
          next()
        }
      }
      const config = await useWaitModData<{ channels: string }>('simple_auto_download_platform')
      const disabledArr = config?.[0]?.channels ? config[0].channels.split(',') : []
      if (!GetChannel() || disabledArr.includes(GetChannel())) {
        return
      }
      //延迟执行，简单处理接口未返回数据的情况
      setTimeout(() => {
        handler()
      }, 1000)
    },
    cpp2js_slient_install_finish: () => {
      AppStore.uninstallSilentInstallSuccess = true
    },
    cpp2js_notify_uninstall_progress: (dir: string, percent: number) => {
      AppStore.UninstallInfo = { dir, percent }
    },
    cpp2js_notify_game_run_status: (status: 1 | 0) => {
      if (status === 1) {
        /*有游戏正在运行*/
        Modal.warn({
          title: '温馨提示',
          className: 'custom AllowClose',
          maskClosable: true,
          content: HasGameRunningModalContent(),
          onOk: () => {
            ReStartGame()
          },
          okText: '重新进入',
        })
      } else {
        ReStartGame()
      }
    },
    cpp2js_notify_doc_status: (type: 1 | 2, key: string, status: 0 | 1) => {
      if (type === 1) {
        let nameShow = key
        //显示时 去掉后面的时间戳
        if (/-_-\d{13}$/.test(key)) {
          nameShow = key.split('-_-')[0]
        }
        /*上传存档*/
        if (status === 1) {
          message.success(`存档"${nameShow}"上传成功!`)
          if (history.location.pathname.startsWith('/Start/')) {
            history.replace(history.location.pathname, { t: Date.now() })
          }
        } else {
          message.warn(`存档"${nameShow}"上传失败!`)
        }
      } else if (status === 1) {
        /*下载存档*/
        AppStore.LocalArchives.push(key)
      }
    },
    cpp2js_notify_game_install_status: (platform: GamePlatform, gameid: number, status: 0 | 1) => {
      ApplyModStore.checkGameInstallTimer && window.clearTimeout(ApplyModStore.checkGameInstallTimer)
      /*查找是否存该游戏的预下载状态*/
      const GameStatus = AppStore.GamePreDownloadStatus.find(d => {
        if (d.GameId === gameid && d.Platform === platform) {
          // d.Status = status
          Object.assign(d, { Status: status })
          return true
        }
        return false
      })
      if (!GameStatus) {
        AppStore.GamePreDownloadStatus.push({ GameId: gameid, Platform: platform, Status: status })
      }
    },
    cpp2js_pc_info_notify: (
      IP: string,
      MAC: string,
      NetWorkMAC: string,
      CPU: string,
      RAM: string,
      DISK: string,
      GRAPH: string,
      SYS: string,
    ) => {
      AppConfig.PCHardwareInfo = { IP, MAC, NetWorkMAC, CPU, RAM, DISK, GRAPH, SYS }
    },
    cpp2js_start_game_platform_status: (platform: GamePlatform, status: 0 | 1) => {
      if (status === 0) {
        if (AppConfig.StartPlatformConfig[platform]) {
          AppStore.toolsPlatformStartFailVisible = true
          AppStore.GamePlatformInstallStatus[platform] = 1
        }
      }
      if (status === 1) {
        AppStore.GamePlatformInstallStatus[platform] = 1
      }
    },
    /** 判断用户某平台是否启动中 */
    cpp2js_notify_gameplatform_running_status: (platform: GamePlatform, status: 0 | 1) => {
      if (status === 0) {
        /** 未启动 */
        const config = AppStore.GamePlatformConfig[platform]
        AppStore.GamePlatformInstallStatus[platform] = 4
        config && window.FuluApp?.JSNotifyCppFunc('start_game_platform', platform, '')
      } else {
        AppStore.toolsPlatformRunningVisible = true
      }
      console.log(status)
    },
    cpp2js_anticheat_download_progress: (progress: number) => {
      AppStore.FWGDownloadProgress = progress
    },
    cpp2js_notify_3rd_speed_status: (id: number, status: 0 | 1 | 2) => {
      AppStore.SpeedClientInstallStatus[id] = status
    },
    cpp2js_notify_3rd_speed_download_progress: (id: number, progress: number) => {
      AppStore.SpeedClientDownloadProgress[id] = progress || 1
    },
    cpp2js_restart_system_dotnet4: () => {
      if (DoNetTips) {
        DDModal.warn({
          title: '温馨提示',
          okText: '现在重启',
          content: DoNetTips,
          onOk: () => {
            window.FuluApp?.JSNotifyCppFunc('restart_system')
          },
        })
      }
    },
    cpp2js_wifi_network: (wifi: 0 | 1) => {
      if (wifi === 1) {
        /*当前网络为 WIFI*/
        window.clearTimeout(DoStartGame.CheckTimer)
        if (sessionStorage.getItem('UseCurrentNetwork')) {
          message.warn('您当前仍使用wifi连接')
          sessionStorage.setItem('WIFINotShow', '0')
          ReStartGame()
        } else {
          let checked = false
          const onChange = (check: boolean) => {
            checked = check
          }
          const modal = Modal.info({
            title: '网络环境提醒',
            content: WifiNetworkTips({ onChange }),
            // okText: '已切换网线,继续启动',
            okText: '我知道了',
            // cancelText: '我知道了',
            className: 'custom',
            zIndex: 1006,
            style: { top: 250 },
            // onOk: () => {
            //   if (checked) {
            //     localStorage.setItem('WIFINotShow', '0')
            //   }
            //   sessionStorage.setItem('UseCurrentNetwork', '1')
            //   ReStartGame()
            // },
            onOk: () => {
              if (checked) {
                localStorage.setItem('WIFINotShow', '0')
              }
              // else {
              //   sessionStorage.setItem('WIFINotShow', '0')
              // }
              // ReStartGame()
              modal.destroy()
            },
          })
        }
      }
    },
    cpp2js_out_of_memory: (memory: number) => {
      window.clearTimeout(DoStartGame.CheckTimer)
      let checked = false
      const onChange = (check: boolean) => {
        checked = check
      }
      const modal = Modal.info({
        title: '电脑配置提醒',
        content: OutOfMemoryTips({ onChange, memory }),
        // okText: '仍然启动',
        okText: '我知道了',
        // cancelText: '我知道了',
        className: 'custom AllowClose',
        zIndex: 1006,
        style: { top: 250 },
        // onOk: () => {
        //   if (checked) {
        //     localStorage.setItem('MemoryNotShow', '0')
        //   } else {
        //     sessionStorage.setItem('MemoryNotShow', '0')
        //   }
        //   ReStartGame()
        // },
        onOk: () => {
          if (checked) {
            localStorage.setItem('MemoryNotShow', '0')
          }
          // else {
          //   sessionStorage.setItem('MemoryNotShow', '0')
          // }
          // HideCheckModal()
          modal.destroy()
          // window.FuluApp?.JSNotifyCppFunc('stop_game', `out of memory ${memory}G`)
        },
      })
    },
    cpp2js_notify_local_doc_recent_time: (key: string, time: string) => {
      AppStore.lastSaveTime = {
        ...AppStore.lastSaveTime,
        [key]: time,
      }
    },
    /** 加速结果通知 */
    // { orderno, gameid, areaid, bStartSuccess }:{orderno:string, gameid:number, areaid:string, bStartSuccess:'1'|'0'}
    cpp2js_start_speed_result: (orderno: string, gameid: number, areaid: string, bStartSuccess: '1' | '0') => {
      /** 选择加速器区服才做处理 */
      if (bStartSuccess === '0' && HaiShaJsqStore.areaInfo) {
        const speedAreaName = AppStore.LastStartGameQuery?.[4]?.speedAreaName
        if (speedAreaName) {
          JsErrorTip({
            onCancel() {
              /** 停止上号 */
              AppStore.CheckModalVisible = false
              AppStore.GameCheckErrorStepMessage = undefined
              AppStore.GameCheckErrorStep = -1
              AppStore.GameCheckStep = 0
              if (window.FuluApp) {
                /*退出登录通知客户端*/
                window.FuluApp.JSNotifyCppFunc('exit_game', 0)
              }
            },
          })
        }
      }
    },
    /** 加速器运行状态 */
    cpp2js_notify_speed_running_status: (status: 0 | 1) => {
      /** 选择加速器区服才做处理 */
      if (HaiShaJsqStore.areaInfo) {
        console.log('cpp2js_notify_speed_running_status', status, typeof status)
        HaiShaJsqStore.JsqRunning = status === 1
      }
    },
    /** 客户端通知游戏进程是否还存在 */
    cpp2js_check_game_process_alive_result: (process: string, isAlive: '0' | '1') => {
      /** 暂不实现 */
      // GameLibraryStore.gameProcessIsAlive = isAlive
      // ConfigStore.saveConfirmVisble = true
    },
    /** 用户主动退出游戏 */
    cpp2js_notify_game_exit: () => {
      console.log('用户主动退出游戏')
      /** 通过这里 接收游戏退出的消息，主要是用于在一些用户不通过我们客户端 直接关闭游戏或其他操作时 做出处理， */
      if (GameLibraryStore.gameRunStatus === 'running') {
        /** 假如用户退出游戏时 我们的游戏状态为running  这里直接改成stop，  其他的状态不改 是因为这个消息可能会跟其他消息冲突， 这里只处理运行中的状态 */
        GameLibraryStore.gameRunStatus = 'stop'
      }
    },
    /** 不需要等待存档弹框 */
    cpp2js_noneed_waitfor_cloud_popup: () => {
      if (GameLibraryStore.gameRunStatus === 'waitClose') {
        GameLibraryStore.gameRunStatus = 'stop'
      }
    },
    /** 登录成功后，客户端启动，回传token */
    cpp2js_notify_user_logon: (token: string) => {
      console.log('客户端通知前端登录成功，回传token: ', token)
      if (token === 'WX_ANONYMOUS_USER_TOKEN') {
        window.FuluApp?.JSNotifyCppFunc('user_logon', 'WX_ANONYMOUS_USER_TOKEN')
        AppStore.WeChatBindMobileVisible = true
        return
      }
      if (token) {
        loginSuccess(token)
        openNotification(token)
        checkModal()
        reportLogin()
      }
    },
    /** 返回剪贴板数据 */
    cpp2js_get_clipboard_reply: (content: string) => {
      window.FuluApp?.clipboardResolve(content)
    },
    /** 返回进程状态 0为进程不存在，1为进程存在 **/
    cpp2js_notify_process_status: (status: 0 | 1) => {
      AppStore.processStatus = status
    },
    /** 返回文件下载状态 // -2为不可用 -1为取消或下载失败， 0为未下载， 1为下载完成， 2为下载中 **/
    cpp2js_file_download_progress: (
      url: string,
      downloadPath: string,
      filePath: string,
      status: TFileDownloadStatus,
      progress: number,
    ) => {
      //下载路径中文处理
      const link = decodeURI(url)
      AppStore.fileDownloadProgress[link] = { url: link, filePath, downloadPath, status, progress }
    },
    cpp2js_client2speed_msg: (msg: string) => {
      SpeedBallStore.client2speedMsg = { time: new Date().getTime(), msg }
    },
    /** 已获取到的安装游戏列表  */
    cpp2js_notify_install_game_list: (list: string) => {
      AppStore.getInstalledGameLoading = false
      AppStore.installedGameList = list?.split?.(',') ?? []
      // AppStore.installedGameList = ['361280','601150','1276790','736190','1225330']
    },
    /** 卸载状态 1-成功 0-失败 2-卸载中 */
    cpp2js_notify_uninstall_status: (gameId: string, status: string, currentProcess: string, code: string) => {
      const s = Number(status)
      if (AppStore.uninstallGameStatus[gameId] !== s) {
        AppStore.uninstallGameStatus[gameId] = s
      }
      if (s === 1) {
        //卸载完成，从已安装列表删除
        const temp = AppStore.installedGameList.concat()
        temp.splice(temp.indexOf(gameId), 1)
        AppStore.installedGameList = temp
        message.success('游戏卸载成功')
      }
      if (s === 2) {
        AppStore.uninstallGameProgress[gameId] = Number(currentProcess ?? 1)
      }
    },
    /** 子窗口关闭 ，eg：开黑窗口 */
    cpp2js_window_closed: (url: string, reason: string) => {
      AppStore.windowClosedInfo = { url, reason }
    },
    /** 截图完成 */
    cpp2js_snapshot_finished(status: 0 | 1, data: any) {
      console.log('cpp2js_snapshot_finished host', status, data)
      AppStore.snapshotData = {
        status,
        data,
      }
    },
    /** 判断当前用户当前CSGO是否处于运行状态 */
    cpp2js_csgo_running_status: (status: 0 | 1) => {
      console.log('cpp2js_csgo_running_status: ', status)
      if (status === 0) {
        AppStore.csgoRunStatusTipVisible = true
      }
      if (history.location.pathname.startsWith('/store/newGame5')) {
        window.gogReport?.('Detailpage_CommunityService_startup')
      } else {
        window.gogReport?.('Mygame_CommunityService_startup')
      }
    },
  }

  if (window.FuluApp) {
    Object.assign(window.FuluApp, Methods)

    Object.keys(Methods).forEach(d => {
      window.FuluApp?.RegisterCppNotifyCppFunc(d, (...arg: any[]) => {
        console.log(`%c => CppNotifyJS:`, 'color:green;font-weight: bold;', d, arg)
        ;(window.FuluApp?.[d as keyof typeof window.FuluApp] as unknown as Function)(...arg)
      })
    })

    const JSNotifyCppFunc = window.FuluApp.JSNotifyCppFunc
    window.FuluApp.JSNotifyCppFunc = (name: any, ...arg: any[]) => {
      console.log('%c <= JSNotifyCpp:', 'color:blue;font-weight: bold;', name, arg)
      JSNotifyCppFunc.apply(window.FuluApp, [name, ...arg])
    }

    const Query = new URLSearchParams(window.location.search.substr(1, window.location.search.length))
    const ver = Query.get('ver') || undefined
    const mac = Query.get('mac') || localStorage.getItem('pc_mac') || ''
    const mId = Query.get('mid')
    mId && localStorage.setItem('mid', mId)
    if (mac) {
      localStorage.setItem('pc_mac', mac)
      if (AppConfig.PCHardwareInfo) {
        AppConfig.PCHardwareInfo.MAC = mac
      } else {
        AppConfig.PCHardwareInfo = { MAC: mac, IP: '', NetWorkMAC: '', CPU: '', RAM: '', DISK: '', GRAPH: '', SYS: '' }
      }
    }
    if (process.env.BUILD_TYPE.includes('Wallpaper')) {
      /*动态壁纸*/
      window.FuluApp.JSNotifyCppFunc('99box_window_size', 1150, 750)
      window.FuluApp.JSNotifyCppFunc('get_local_wallpaper_cfg')
    } else if (process.env.BUILD_TYPE.includes('Uninstall')) {
      /*卸载页*/
      window.FuluApp.JSNotifyCppFunc('99box_window_size', 504, 300)
      //ChannelConfigHS.Execute({ ver, channel: GetChannel() })
      LoadChannelConfig(false, ver)
    } else if (process.env.BUILD_TYPE.includes('Update')) {
      /*自动更新页*/
      window.FuluApp.JSNotifyCppFunc('99box_window_size', 560, 280)
      //ChannelConfigHS.Execute({ ver, channel: GetChannel() })
      // LoadChannelConfig(false, ver)
    } else if (process.env.BUILD_TYPE.includes('SpeedBall')) {
      // speedBall
      console.log('SpeedBall cef')
    } else {
      /*内嵌页*/
      /*没有版本号的时候*/
      !ver && window.FuluApp.JSNotifyCppFunc('need_version')
      window.setTimeout(() => {
        /*两秒之后再去获取电脑硬件配置信息  防止页面加载阻塞*/
        window.FuluApp?.JSNotifyCppFunc('need_pc_info')
        window.FuluApp?.JSNotifyCppFunc('99box_window_size', 1280, 830)
      }, 2000)
      LoadCMSConfigForClient() //加载客户端配置
      //获取已安装的游戏
      getInstalledGameList()
    }
  } else {
    LoadChannelConfig(true, undefined, true)
  }
}

// /** 发送方 */
// const payload = {
//   method: 'checkLogin',
//   params: {}
// }

// window.parent.postMessage(JSON.stringify(payload), '*')

/** 接收方 */
type TMethod = 'openUrl'
type TPayload = {
  method: TMethod
  params: {
    token?: String
    url?: String
  }
}
const methodCallback = {
  openUrl: (url: string) => {
    window?.FuluApp?.JSNotifyCppFunc('open_url', url)
    const PreProcessInfo = GetPreProcessHS.SuccessResult
    DWSaveUrlHttp.Execute({
      op: 'c5OpenUrl',
      subjectId: PreProcessInfo?.id as string,
      mss: {
        pageUrl: url,
      },
    })
  },
}
window.addEventListener('message', e => {
  /** 这里主要一定要判断这个消息来源是否是我们页面传过来的， 避免出现安全问题。 */
  if (!['https://fl.zeroskins.com', 'https://box.9mgame.com'].includes(e.origin) || !e.data) {
    return
  }
  try {
    const { method, params } = JSON.parse(e.data) as TPayload
    /** 业务代码 */
    methodCallback[method](params?.url as string)
  } catch (error) {
    console.log(error)
  }
})
